import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { GetStatementsResponse } from '@iwoca/lapi-client/edge';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow
} from '@ui';
import { FormattedDate, FormattedMessage } from 'react-intl';

import messages from '../AccountHistoryTable.messages';

const parseTransactionNumber = (number: number) =>
    number ? Math.abs(number) : 0;

export const AccountStatementTable = ({
    accountStatement
}: {
    accountStatement: GetStatementsResponse['data'][number];
}) => {
    const productType = accountStatement.product_type;
    const statementsWithMostRecentFirst =
        accountStatement.statements!.reverse();

    return (
        <Table data-testid="account-statement-table">
            <TableHeader>
                <TableRow>
                    <TableHead>
                        <FormattedMessage {...messages.date} />
                    </TableHead>
                    <TableHead />
                    {productType !== 'merchant_cash_advance' && (
                        <>
                            <TableHead>
                                <FormattedMessage {...messages.principal} />
                            </TableHead>
                            <TableHead>
                                <FormattedMessage {...messages.interest} />
                            </TableHead>
                        </>
                    )}
                    <TableHead>
                        <FormattedMessage {...messages.balance} />
                    </TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {statementsWithMostRecentFirst.map((statement, index) => (
                    <TableRow key={index}>
                        <TableCell>
                            <FormattedDate
                                day="numeric"
                                month="short"
                                year="numeric"
                                value={new Date(statement.date!)}
                            />
                        </TableCell>
                        <TableCell>{statement.description}</TableCell>
                        {productType !== 'merchant_cash_advance' && (
                            <>
                                <TableCell>
                                    <FormattedCurrency
                                        value={parseTransactionNumber(
                                            statement.transaction_principal!
                                        )}
                                    />
                                </TableCell>
                                <TableCell>
                                    <FormattedCurrency
                                        value={
                                            parseTransactionNumber(
                                                statement.transaction_interest!
                                            ) +
                                            parseTransactionNumber(
                                                statement.transaction_fees!
                                            )
                                        }
                                    />
                                </TableCell>
                            </>
                        )}
                        <TableCell>
                            <FormattedCurrency
                                value={statement.closing_balance}
                            />
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
